/* Utilitiy functions for payment */
import {loadStripe} from '@stripe/stripe-js';

let stripePromise = null;
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(window.stripe_publishable_key);
  }
  return stripePromise;
};

const stripeElementBaseOptions = {style: {base: {fontSize: '16px'}}};
const stripeCardNumberElementOptions = {...stripeElementBaseOptions, showIcon: true};

export {getStripe, stripeElementBaseOptions, stripeCardNumberElementOptions};
